// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/site/img/chevron_down_small.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../assets/site/img/calendar.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lk {
    margin: 58px 0 80px 0;
}

.lk .container {
    max-width: 1150px;
    display: flex;
}

@media screen and (max-width: 1024px) {
    .lk .container {
        display: block;
    }
}

.lk-aside {
    max-width: 305px;
    width: 100%;
    flex-shrink: 0;
    margin-right: 64px;
}

@media screen and (max-width: 1024px) {
    .lk-aside {
        display: none;
    }
}

.lk-aside__link {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    display: flex;
    align-items: center;
    padding: 9px 16px;
    margin-bottom: 8px;
}

.lk-aside__link:last-child {
    margin-bottom: 0;
}

.lk-aside__link svg {
    margin-right: 16px;
}

.lk-aside__link svg path {
    fill: var(--color-gray-window);
}

.lk-aside__link._active {
    font-family: "RalewaySemiBold";
    background: var(--color-light-periwinkle-crayola);
}

.lk-wrapper {
    width: 100%;
}

.lk-wrapper__top {
    display: flex;
}

@media screen and (max-width: 1024px) {
    .lk-wrapper__top {
        flex-direction: column;
    }
}

.lk-wrapper__empty {
    font-size: 24px;
    line-height: 32px;
    color: var(--color-gray-window);
    margin-top: 24px;
}

.lk-wrapper__list {
    margin-top: 16px;
}

.lk-wrapper__item {
    padding: 24px 32px 22px;
    border: 1px solid var(--color-light-periwinkle-crayola);
    border-radius: 6px;
    margin-bottom: 16px;
    position: relative;
}

@media screen and (max-width: 576px) {
    .lk-wrapper__item {
        padding: 16px;
    }
}

.lk-wrapper__item-right {
    position: absolute;
    top: 24px;
    right: 32px;
}

@media screen and (max-width: 767px) {
    .lk-wrapper__item-right {
        position: relative;
        top: initial;
        right: initial;
        margin-top: 16px;
    }
}

@media screen and (max-width: 576px) {
    .lk-wrapper__item-right {
        display: flex;
        flex-direction: column;
    }
}

.lk-wrapper__item-number {
    font-size: 20px;
    line-height: 26px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 4px;
}

.lk-wrapper__item-date {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

.lk-wrapper__item-pay {
    font-size: 14px;
    line-height: 22px;
    padding: 5px 12px;
    display: inline-block;
    height: 32px;
}

@media screen and (max-width: 576px) {
    .lk-wrapper__item-pay {
        margin-bottom: 8px;
        align-self: baseline;
    }
}

.lk-wrapper__item-detail {
    font-size: 14px;
    line-height: 22px;
    color: var(--color-main);
    font-family: "RalewaySemiBold";
    padding: 5px 12px;
    background: var(--color-light-periwinkle-crayola);
    display: inline-block;
    margin-left: 8px;
    border-radius: 4px;
    height: 32px;
}

@media screen and (max-width: 576px) {
    .lk-wrapper__item-detail {
        align-self: baseline;
        margin-left: 0;
    }
}

.lk-wrapper__item-block {
    margin-top: 24px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: stretch;
    align-items: start;
}

.lk-wrapper__item-block > div {
    flex: 1 1 50%;
}

.lk-wrapper__item-images {
    display: flex;
    gap: 15px;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: flex-start;
}

.lk-wrapper__item-image {
    flex: 0 1 100px;
    max-width: 100%;
}

.lk-wrapper__item-image > img {
    width: 100%;
    height: auto;
}

.lk-wrapper__item-line {
    display: flex;
    margin-bottom: 4px;
}

.lk-wrapper__item-line:first-child .lk-wrapper__item-value {
    font-family: "RalewaySemiBold";
}

.lk-wrapper__item-line:nth-child(2) {
    font-family: "RalewaySemiBold";
}

.lk-wrapper__item-text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    max-width: 96px;
    width: 100%;
    flex-shrink: 0;
    margin-right: 8px;
}

@media screen and (max-width: 576px) {
    .lk-wrapper__item-text {
        max-width: 80px;
        margin-right: 16px;
    }
}

.lk-wrapper__item-value {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    width: 100%;
}

.lk-wrapper__item-waite {
    color: var(--color-blue-steel);
}

.lk-wrapper__item-cancel span {
    font-family: "RalewayRegular";
}

.lk-wrapper__item-success {
    color: var(--color-mint);
}

.lk-filter {
    position: relative;
    cursor: pointer;
}

.lk-filter:first-child {
    width: 160px;
    margin-right: 8px;
}

@media screen and (max-width: 1024px) {
    .lk-filter:first-child {
        width: 100%;
        margin-right: 0;
        margin-bottom: 8px;
    }
}

.lk-filter:last-child {
    width: 200px;
}

@media screen and (max-width: 1024px) {
    .lk-filter:last-child {
        width: 100%;
    }
}

.lk-filter._active .lk-filter__body {
    display: block;
    opacity: 1;
    visibility: visible;
}

.lk-filter._active:after {
    -webkit-transform: translateY(-50%) scale(-1);
    transform: translateY(-50%) scale(-1);
}

.lk-filter:after {
    position: absolute;
    content: '';
    top: 50%;
    right: 8px;
    width: 24px;
    height: 24px;
    -webkit-transform: translateY(-50%) scale(1);
    transform: translateY(-50%) scale(1);
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
    background-size: contain;
}

.lk-filter__top {
    display: flex;
    align-items: center;
    border-radius: 4px;
    height: 40px;
    padding: 0 12px;
    border: 1px solid var(--color-pale-blue);
    position: relative;
    z-index: 1;
}

.lk-filter__title {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.lk-filter__body {
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    max-height: 240px;
    overflow-y: auto;
    box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);
    border-radius: 4px;
    display: none;
    opacity: 0;
    background: #fff;
    padding: 8px 0;
    visibility: hidden;
    z-index: 2;
}

.lk-filter__body-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
}

.lk-detail__title {
    font-size: 32px;
    line-height: 40px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
}

@media screen and (max-width: 1024px) {
    .lk-detail__title {
        text-align: center;
        font-size: 20px;
        line-height: 26px;
    }
}

.lk-detail__more {
    font-size: 14px;
    line-height: 22px;
    color: var(--color-main);
    font-family: "RalewaySemiBold";
    padding: 5px 12px;
    background: var(--color-light-periwinkle-crayola);
    display: inline-block;
    border-radius: 4px;
    margin-top: 8px;
    height: 32px;
}

.lk-detail__block {
    margin-top: 24px;
}

.lk-detail__line {
    display: flex;
}

.lk-detail__line:nth-child(2) .lk-detail__value {
    font-family: "RalewaySemiBold";
}

.lk-detail__text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    max-width: 96px;
    width: 100%;
    margin-right: 16px;
}

.lk-detail__value {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.lk-detail__subtitle {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-top: 24px;
    margin-bottom: 2px;
}

.lk-detail__subtext {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.lk-detail__subtext span {
    font-family: "RalewaySemiBold";
}

.lk-detail__pay {
    font-size: 18px;
    line-height: 28px;
    color: var(--color-white);
    padding: 14px 24px;
    background: var(--color-main);
    border-radius: 4px;
    display: inline-block;
    margin-top: 12px;
}

@media screen and (max-width: 1024px) {
    .lk-detail__pay {
        font-size: 16px;
        line-height: 24px;
        padding: 12px 20px;
    }
}

.lk-detail__info {
    font-size: 14px;
    line-height: 22px;
    color: var(--color-blue-steel);
}

.lk-detail__cancel {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    display: flex;
    align-items: center;
    margin-top: 24px;
    width: 154px;
}

.lk-detail__cancel svg {
    margin-right: 8px;
}

.lk-detail__cancel svg path {
    fill: var(--color-gray-window);
}

.lk-detail__list {
    margin-top: 62px;
}

.lk-detail__list-title {
    font-size: 24px;
    line-height: 32px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 16px;
}

.lk-detail__list-return {
    display: flex;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    cursor: pointer;
    margin: 20px 0;
}

.lk-detail__list-return svg {
    margin-right: 8px;
}

.lk-detail__list-return svg path {
    fill: var(--color-blackberry);
}

.lk-detail__item {
    border-top: 1px solid var(--color-light-periwinkle-crayola);
    padding-top: 16px;
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
}

.lk-detail__item-img {
    display: block;
    width: 120px;
    height: 180px;
    -o-object-fit: contain;
    object-fit: contain;
    margin-right: 16px;
}

@media screen and (max-width: 576px) {
    .lk-detail__item-img {
        width: 48px;
        height: 73px;
        margin-right: 12px;
    }
}

.lk-detail__item-body {
    width: 100%;
}

.lk-detail__item-title {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    margin-bottom: 4px;
}

.lk-detail__item-property {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

.lk-detail__item-right {
    width: 75px;
    text-align: right;
    flex-shrink: 0;
}

.lk-detail__item-price {
    font-size: 16px;
    line-height: 22px;
    color: var(--color-granite);
    margin-bottom: 4px;
}

.lk-detail__item-count {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

.lk-cashback__title {
    font-size: 24px;
    line-height: 32px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
}

@media screen and (max-width: 1024px) {
    .lk-cashback__title {
        font-size: 20px;
        line-height: 26px;
    }
}

.lk-cashback__block {
    margin-top: 24px;
    margin-bottom: 32px;
    background: var(--color-periwinkle-crayola);
    border-radius: 4px;
    padding: 16px 16px 16px 21px;
    display: flex;
    align-items: center;
}

.lk-cashback__block-icon {
    flex-shrink: 0;
    width: 30px;
    height: 28px;
    -o-object-fit: contain;
    object-fit: contain;
    display: block;
    margin-right: 21px;
}

.lk-cashback__block-right {
    width: 100%;
}

.lk-cashback__block-text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.lk-cashback__block-more {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blue-steel);
    display: inline-block;
}

.lk-cashback__subtitle {
    font-size: 16px;
    line-height: 20px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 18px;
}

.lk-cashback .reviews-form__label {
    width: 240px;
    height: 40px;
}

@media screen and (max-width: 1024px) {
    .lk-cashback .checkout-label {
        display: block;
    }
}

.lk-cashback__btn {
    padding: 12px 20px;
    font-size: 16px;
    line-height: 24px;
    border: none;
}

.lk-cashback__btn:focus {
    outline: none;
}

.lk-cashback__top {
    display: flex;
    align-items: center;
    margin-bottom: 46px;
}

@media screen and (max-width: 767px) {
    .lk-cashback__top {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 42px;
    }
}

.lk-cashback__bonus {
    padding: 16px 24px 16px 16px;
    border-radius: 6px;
    border: 1px solid var(--color-light-periwinkle-crayola);
    margin-right: 32px;
}

@media screen and (max-width: 767px) {
    .lk-cashback__bonus {
        margin-bottom: 24px;
        margin-right: 0;
        width: 100%;
    }
}

.lk-cashback__bonus-count {
    font-size: 48px;
    line-height: 56px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
}

.lk-cashback__bonus-text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.lk-cashback__bonus-more {
    font-size: 14px;
    line-height: 22px;
    color: var(--color-blue-steel);
    display: inline-block;
}

.lk-cashback__bonus-empty {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
}

@media screen and (max-width: 767px) {
    .lk-cashback__info {
        width: 100%;
    }
}

.lk-cashback__info-title {
    font-size: 18px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 4px;
}

.lk-cashback__info-text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    margin-bottom: 4px;
}

.lk-cashback__info-text:last-child {
    margin-bottom: 0;
}

.lk-cashback__history {
    font-size: 18px;
    line-height: 24px;
    color: var(--color-granite);
    margin-bottom: 16px;
}

.lk-cashback__head {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    margin-bottom: 16px;
    display: flex;
    align-items: center;
}

@media screen and (max-width: 767px) {
    .lk-cashback__head {
        display: none;
    }
}

.lk-cashback__head-name {
    width: 45%;
}

.lk-cashback__head-date {
    width: 30%;
}

.lk-cashback__head-operation {
    width: 13%;
}

.lk-cashback__head-total {
    width: 12%;
}

.lk-cashback__item {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    padding: 16px 0;
    display: flex;
    align-items: center;
    border-top: 1px solid var(--color-light-periwinkle-crayola);
}

@media screen and (max-width: 767px) {
    .lk-cashback__item {
        flex-wrap: wrap;
    }
}

.lk-cashback__item span {
    display: none;
}

@media screen and (max-width: 767px) {
    .lk-cashback__item span {
        display: inline-block;
        color: var(--color-blackberry);
    }
}

.lk-cashback__item:last-child {
    margin-bottom: 32px;
}

.lk-cashback__item-name {
    width: 45%;
}

@media screen and (max-width: 767px) {
    .lk-cashback__item-name {
        width: 100%;
    }
}

.lk-cashback__item-date {
    width: 30%;
}

@media screen and (max-width: 767px) {
    .lk-cashback__item-date {
        width: 100%;
        font-size: 14px;
        line-height: 18px;
        color: var(--color-blackberry);
    }
}

.lk-cashback__item-operation {
    width: 13%;
}

@media screen and (max-width: 767px) {
    .lk-cashback__item-operation {
        width: 50%;
        margin-top: 8px;
    }
}

.lk-cashback__item-plus {
    color: var(--color-mint);
}

.lk-cashback__item-total {
    width: 12%;
}

@media screen and (max-width: 767px) {
    .lk-cashback__item-total {
        width: 50%;
        text-align: right;
        margin-top: 8px;
    }
}

.lk-departure__title {
    font-size: 18px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 16px;
}

.lk-departure .reviews-form__label {
    width: 240px;
    height: 40px;
}

.lk-departure__btn {
    font-size: 16px;
    line-height: 24px;
    padding: 12px 20px;
    border: none;
}

.lk-departure__btn:focus {
    outline: none;
}

.lk-departure__error {
    margin-top: 32px;
    max-width: 600px;
    width: 100%;
}

.lk-departure__error-title {
    font-size: 18px;
    line-height: 24px;
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin-bottom: 8px;
}

.lk-departure__error-text {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
}

.lk-departure__subtitle {
    font-size: 18px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-top: 32px;
    margin-bottom: 16px;
}

.lk-departure__head {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    display: flex;
    align-items: center;
    padding-bottom: 16px;
}

@media screen and (max-width: 767px) {
    .lk-departure__head {
        display: none;
    }
}

.lk-departure__head-number {
    width: 5%;
}

@media screen and (max-width: 1024px) {
    .lk-departure__head-number {
        width: 10%;
    }
}

.lk-departure__head-date {
    width: 30%;
}

@media screen and (max-width: 1024px) {
    .lk-departure__head-date {
        width: 20%;
    }
}

.lk-departure__head-name {
    width: 30%;
}

.lk-departure__head-address {
    width: 30%;
}

.lk-departure__item {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-granite);
    border-top: 1px solid var(--color-light-periwinkle-crayola);
    padding: 16px 0;
    display: flex;
    align-items: center;
}

@media screen and (max-width: 767px) {
    .lk-departure__item {
        align-items: flex-start;
    }
}

.lk-departure__item span {
    display: none;
    font-size: 16px;
    line-height: 22px;
    color: var(--color-blackberry);
    flex-shrink: 0;
    margin-right: 12px;
    width: 102px;
    margin-bottom: 4px;
}

@media screen and (max-width: 767px) {
    .lk-departure__item span {
        display: block;
    }
}

.lk-departure__item-number {
    width: 5%;
}

@media screen and (max-width: 1024px) {
    .lk-departure__item-number {
        width: 10%;
    }
}

.lk-departure__item-wrap {
    width: 90%;
    display: flex;
}

@media screen and (max-width: 767px) {
    .lk-departure__item-wrap {
        flex-wrap: wrap;
    }
}

.lk-departure__item-date {
    display: flex;
    align-items: center;
    width: 100%;
}

@media screen and (max-width: 767px) {
    .lk-departure__item-date {
        align-items: flex-start;
    }
}

.lk-departure__item-name {
    display: flex;
    align-items: center;
    width: 100%;
}

@media screen and (max-width: 767px) {
    .lk-departure__item-name {
        align-items: flex-start;
    }
}

.lk-departure__item-address {
    display: flex;
    align-items: center;
    width: 100%;
}

@media screen and (max-width: 767px) {
    .lk-departure__item-address {
        align-items: flex-start;
    }
}

.lk-profile__title {
    font-size: 18px;
    line-height: 24px;
    color: var(--color-granite);
    font-family: "RalewaySemiBold";
    margin-bottom: 24px;
}

.lk-profile__personal {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 400px;
    margin: 0 auto;
    max-width: 100%;
}

@media screen and (max-width: 1024px) {
    .lk-profile__personal {
    }
}

.lk-profile__personal-remove {
    display: none;
    font-size: 14px;
    line-height: 22px;
    font-family: "RalewaySemiBold";
    color: var(--color-main);
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
    padding: 5px 12px;
    margin: 8px 0 0 16px;
}

.lk-profile__personal-remove._active {
    display: inline-block;
}

.lk-profile__personal-right {
    padding-top: 30px;
    display: flex;
    align-items: center;
    margin-left: 40px;
}

@media screen and (max-width: 1024px) {
    .lk-profile__personal-right {
        padding-top: 0;
        margin-bottom: 24px;
        margin-left: 0;
    }
}


.lk-profile__personal-label {
    font-size: 14px;
    line-height: 22px;
    color: var(--color-main);
    font-family: "RalewaySemiBold";
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 5px 12px;
    cursor: pointer;
    border: 1px solid var(--color-pale-blue);
    border-radius: 4px;
    margin-left: 16px;
    display: block;
}

.lk-profile__personal-input {
    width: .1px;
    height: .1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.lk-profile .checkout-label {
    margin-bottom: 0;
}

.lk-profile .lk-filter {
    width: 356px;
    background: var(--color-light-periwinkle-crayola);
}

@media screen and (max-width: 1024px) {
    .lk-profile .lk-filter {
        width: 100%;
    }
}

.lk-profile__success {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-main);
    font-family: "RalewaySemiBold";
    padding: 8px 16px;
    border-radius: 4px;
    border: 1px solid var(--color-pale-blue);
    margin-top: 12px;
    background: transparent;
}

.lk-profile__wrap {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.lk-profile__block {
    text-align: center;
    padding: 15px;
}

.lk-profile__save {
    font-size: 16px;
    line-height: 24px;
    margin-right: 20px;
    padding: 12px 20px;
    border: none;
}

.lk-profile__save-info {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 22px;
    color: var(--color-blue-steel);
}

.lk-profile__save-info svg {
    margin-right: 8px;
}

.lk-profile__notice {
    margin-top: 64px;
}

@media screen and (max-width: 1024px) {
    .lk-profile__notice .lk-profile__title {
        margin-bottom: 12px;
    }
}

.lk-profile__head {
    display: flex;
    align-items: center;
    padding-bottom: 18px;
    text-align: center;
}

@media screen and (max-width: 1024px) {
    .lk-profile__head {
        display: none;
    }
}

.lk-profile__head-notification {
    width: 32%;
    text-align: left;
}

.lk-profile__head-email {
    width: 17%;
}

.lk-profile__head-push {
    width: 17%;
}

.lk-profile__head-sms {
    width: 17%;
}

.lk-profile__head-viber {
    width: 17%;
}

.lk-profile__item {
    display: flex;
    align-items: center;
    border-top: 1px solid var(--color-light-periwinkle-crayola);
    padding: 18px 0;
}

@media screen and (max-width: 1024px) {
    .lk-profile__item {
        border-top: none;
        flex-wrap: wrap;
        padding: 12px 0;
    }
}

@media screen and (max-width: 1024px) {
    .lk-profile__item .checkout-label {
        display: block;
        margin-bottom: 12px;
    }
}

@media screen and (max-width: 1024px) {
    .lk-profile__item .checkout-label__text {
        padding-left: 0;
    }
}

.lk-profile__item .checkout-label__text span {
    display: none;
}

@media screen and (max-width: 1024px) {
    .lk-profile__item .checkout-label__text span {
        display: inline-block;
    }
}

.lk-profile__item .checkout-label__text:before {
    position: absolute;
    content: '';
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

@media screen and (max-width: 1024px) {
    .lk-profile__item .checkout-label__text:before {
        right: 0;
        left: initial;
        -webkit-transform: translate(0, -50%);
        transform: translate(0, -50%);
        width: 34px;
        height: 14px;
        background: var(--color-light-periwinkle-crayola);
        border-radius: 500px;
    }
}

@media screen and (max-width: 1024px) {
    .lk-profile__item .checkout-label__text:after {
        position: absolute;
        content: '';
        width: 20px;
        height: 20px;
        right: 0;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        background: var(--color-main);
        border-radius: 50%;
        transition: right .3s linear;
    }
}

.lk-profile__item .checkout-label__input:checked + .checkout-label__text:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

@media screen and (max-width: 1024px) {
    .lk-profile__item .checkout-label__input:checked + .checkout-label__text:after {
        position: absolute;
        content: '';
        width: 20px;
        height: 20px;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        background: var(--color-main);
        border-radius: 50%;
        right: 20px;
        left: initial;
    }
}

.lk-profile__item-notification {
    width: 32%;
}

@media screen and (max-width: 1024px) {
    .lk-profile__item-notification {
        width: 100%;
        font-size: 16px;
        line-height: 24px;
        color: var(--color-granite);
        font-family: "RalewaySemiBold";
        margin-bottom: 12px;
    }
}

.lk-profile__item-email {
    width: 17%;
}

@media screen and (max-width: 1024px) {
    .lk-profile__item-email {
        width: 100%;
    }
}

.lk-profile__item-push {
    width: 17%;
}

@media screen and (max-width: 1024px) {
    .lk-profile__item-push {
        width: 100%;
    }
}

.lk-profile__item-sms {
    width: 17%;
}

@media screen and (max-width: 1024px) {
    .lk-profile__item-sms {
        width: 100%;
    }
}

.lk-profile__item-viber {
    width: 17%;
}

@media screen and (max-width: 1024px) {
    .lk-profile__item-viber {
        width: 100%;
    }
}

.lk-profile .reviews-form__input::-webkit-datetime-edit {
    font-size: 16px;
    line-height: 24px;
    color: var(--color-blackberry);
    font-family: "RalewayRegular";
}

.lk-profile .reviews-form__input::-webkit-calendar-picker-indicator {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
    background-size: contain;
}

.lk-profile__radio {
    display: flex;
    flex-direction: row;
    justify-content: start;
    gap: 30px;
}

.lk-profile__radio > label {

}

.lk-profile__radio > label > input {
}

.lk-profile__radio > label > span {
    display: inline-block;
    padding-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./resources/views/site/lk/main.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,iDAAiD;AACrD;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,uDAAuD;IACvD,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,cAAc;QACd,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;IAC1B;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI;QACI,kBAAkB;QAClB,oBAAoB;IACxB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,iBAAiB;IACjB,iDAAiD;IACjD,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI;QACI,oBAAoB;QACpB,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,6CAA6C;IAC7C,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,oCAAoC;IACpC,6DAA4E;IAC5E,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,wCAAwC;IACxC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,6CAA6C;IAC7C,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,iBAAiB;IACjB,iDAAiD;IACjD,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,kBAAkB;IACtB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2DAA2D;IAC3D,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,2CAA2C;IAC3C,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;AACJ;;AAEA;IACI,4BAA4B;IAC5B,kBAAkB;IAClB,uDAAuD;IACvD,kBAAkB;AACtB;;AAEA;IACI;QACI,mBAAmB;QACnB,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,2DAA2D;AAC/D;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,qBAAqB;QACrB,8BAA8B;IAClC;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,8BAA8B;IAClC;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;QACV,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,2BAA2B;IAC3B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,2DAA2D;IAC3D,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI;IACA;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,wBAAwB;IACxB,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;QACnB,cAAc;IAClB;AACJ;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iDAAiD;AACrD;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2DAA2D;IAC3D,eAAe;AACnB;;AAEA;IACI;QACI,gBAAgB;QAChB,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA;IACI;QACI,QAAQ;QACR,aAAa;QACb,qCAAqC;QACrC,6BAA6B;QAC7B,WAAW;QACX,YAAY;QACZ,iDAAiD;QACjD,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,QAAQ;QACR,mCAAmC;QACnC,2BAA2B;QAC3B,6BAA6B;QAC7B,kBAAkB;QAClB,4BAA4B;IAChC;AACJ;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,gCAAgC;AACpC;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,mCAAmC;QACnC,2BAA2B;QAC3B,6BAA6B;QAC7B,kBAAkB;QAClB,WAAW;QACX,aAAa;IACjB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;QACjB,2BAA2B;QAC3B,8BAA8B;QAC9B,mBAAmB;IACvB;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,6DAAkE;IAClE,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;AACb;;AAEA;;AAEA;;AAEA;AACA;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB","sourcesContent":[".lk {\n    margin: 58px 0 80px 0;\n}\n\n.lk .container {\n    max-width: 1150px;\n    display: flex;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk .container {\n        display: block;\n    }\n}\n\n.lk-aside {\n    max-width: 305px;\n    width: 100%;\n    flex-shrink: 0;\n    margin-right: 64px;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-aside {\n        display: none;\n    }\n}\n\n.lk-aside__link {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    display: flex;\n    align-items: center;\n    padding: 9px 16px;\n    margin-bottom: 8px;\n}\n\n.lk-aside__link:last-child {\n    margin-bottom: 0;\n}\n\n.lk-aside__link svg {\n    margin-right: 16px;\n}\n\n.lk-aside__link svg path {\n    fill: var(--color-gray-window);\n}\n\n.lk-aside__link._active {\n    font-family: \"RalewaySemiBold\";\n    background: var(--color-light-periwinkle-crayola);\n}\n\n.lk-wrapper {\n    width: 100%;\n}\n\n.lk-wrapper__top {\n    display: flex;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-wrapper__top {\n        flex-direction: column;\n    }\n}\n\n.lk-wrapper__empty {\n    font-size: 24px;\n    line-height: 32px;\n    color: var(--color-gray-window);\n    margin-top: 24px;\n}\n\n.lk-wrapper__list {\n    margin-top: 16px;\n}\n\n.lk-wrapper__item {\n    padding: 24px 32px 22px;\n    border: 1px solid var(--color-light-periwinkle-crayola);\n    border-radius: 6px;\n    margin-bottom: 16px;\n    position: relative;\n}\n\n@media screen and (max-width: 576px) {\n    .lk-wrapper__item {\n        padding: 16px;\n    }\n}\n\n.lk-wrapper__item-right {\n    position: absolute;\n    top: 24px;\n    right: 32px;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-wrapper__item-right {\n        position: relative;\n        top: initial;\n        right: initial;\n        margin-top: 16px;\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .lk-wrapper__item-right {\n        display: flex;\n        flex-direction: column;\n    }\n}\n\n.lk-wrapper__item-number {\n    font-size: 20px;\n    line-height: 26px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 4px;\n}\n\n.lk-wrapper__item-date {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n.lk-wrapper__item-pay {\n    font-size: 14px;\n    line-height: 22px;\n    padding: 5px 12px;\n    display: inline-block;\n    height: 32px;\n}\n\n@media screen and (max-width: 576px) {\n    .lk-wrapper__item-pay {\n        margin-bottom: 8px;\n        align-self: baseline;\n    }\n}\n\n.lk-wrapper__item-detail {\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--color-main);\n    font-family: \"RalewaySemiBold\";\n    padding: 5px 12px;\n    background: var(--color-light-periwinkle-crayola);\n    display: inline-block;\n    margin-left: 8px;\n    border-radius: 4px;\n    height: 32px;\n}\n\n@media screen and (max-width: 576px) {\n    .lk-wrapper__item-detail {\n        align-self: baseline;\n        margin-left: 0;\n    }\n}\n\n.lk-wrapper__item-block {\n    margin-top: 24px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: stretch;\n    align-items: start;\n}\n\n.lk-wrapper__item-block > div {\n    flex: 1 1 50%;\n}\n\n.lk-wrapper__item-images {\n    display: flex;\n    gap: 15px;\n    flex-wrap: wrap;\n    flex-direction: row;\n    align-items: flex-start;\n}\n\n.lk-wrapper__item-image {\n    flex: 0 1 100px;\n    max-width: 100%;\n}\n\n.lk-wrapper__item-image > img {\n    width: 100%;\n    height: auto;\n}\n\n.lk-wrapper__item-line {\n    display: flex;\n    margin-bottom: 4px;\n}\n\n.lk-wrapper__item-line:first-child .lk-wrapper__item-value {\n    font-family: \"RalewaySemiBold\";\n}\n\n.lk-wrapper__item-line:nth-child(2) {\n    font-family: \"RalewaySemiBold\";\n}\n\n.lk-wrapper__item-text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    max-width: 96px;\n    width: 100%;\n    flex-shrink: 0;\n    margin-right: 8px;\n}\n\n@media screen and (max-width: 576px) {\n    .lk-wrapper__item-text {\n        max-width: 80px;\n        margin-right: 16px;\n    }\n}\n\n.lk-wrapper__item-value {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    width: 100%;\n}\n\n.lk-wrapper__item-waite {\n    color: var(--color-blue-steel);\n}\n\n.lk-wrapper__item-cancel span {\n    font-family: \"RalewayRegular\";\n}\n\n.lk-wrapper__item-success {\n    color: var(--color-mint);\n}\n\n.lk-filter {\n    position: relative;\n    cursor: pointer;\n}\n\n.lk-filter:first-child {\n    width: 160px;\n    margin-right: 8px;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-filter:first-child {\n        width: 100%;\n        margin-right: 0;\n        margin-bottom: 8px;\n    }\n}\n\n.lk-filter:last-child {\n    width: 200px;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-filter:last-child {\n        width: 100%;\n    }\n}\n\n.lk-filter._active .lk-filter__body {\n    display: block;\n    opacity: 1;\n    visibility: visible;\n}\n\n.lk-filter._active:after {\n    -webkit-transform: translateY(-50%) scale(-1);\n    transform: translateY(-50%) scale(-1);\n}\n\n.lk-filter:after {\n    position: absolute;\n    content: '';\n    top: 50%;\n    right: 8px;\n    width: 24px;\n    height: 24px;\n    -webkit-transform: translateY(-50%) scale(1);\n    transform: translateY(-50%) scale(1);\n    background: url(\"../../../assets/site/img/chevron_down_small.svg\") no-repeat;\n    background-size: contain;\n}\n\n.lk-filter__top {\n    display: flex;\n    align-items: center;\n    border-radius: 4px;\n    height: 40px;\n    padding: 0 12px;\n    border: 1px solid var(--color-pale-blue);\n    position: relative;\n    z-index: 1;\n}\n\n.lk-filter__title {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.lk-filter__body {\n    position: absolute;\n    top: 40px;\n    left: 0;\n    width: 100%;\n    max-height: 240px;\n    overflow-y: auto;\n    box-shadow: 0px 4px 16px rgba(8, 11, 48, 0.2);\n    border-radius: 4px;\n    display: none;\n    opacity: 0;\n    background: #fff;\n    padding: 8px 0;\n    visibility: hidden;\n    z-index: 2;\n}\n\n.lk-filter__body-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 16px;\n    cursor: pointer;\n}\n\n.lk-detail__title {\n    font-size: 32px;\n    line-height: 40px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-detail__title {\n        text-align: center;\n        font-size: 20px;\n        line-height: 26px;\n    }\n}\n\n.lk-detail__more {\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--color-main);\n    font-family: \"RalewaySemiBold\";\n    padding: 5px 12px;\n    background: var(--color-light-periwinkle-crayola);\n    display: inline-block;\n    border-radius: 4px;\n    margin-top: 8px;\n    height: 32px;\n}\n\n.lk-detail__block {\n    margin-top: 24px;\n}\n\n.lk-detail__line {\n    display: flex;\n}\n\n.lk-detail__line:nth-child(2) .lk-detail__value {\n    font-family: \"RalewaySemiBold\";\n}\n\n.lk-detail__text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    max-width: 96px;\n    width: 100%;\n    margin-right: 16px;\n}\n\n.lk-detail__value {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.lk-detail__subtitle {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-top: 24px;\n    margin-bottom: 2px;\n}\n\n.lk-detail__subtext {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.lk-detail__subtext span {\n    font-family: \"RalewaySemiBold\";\n}\n\n.lk-detail__pay {\n    font-size: 18px;\n    line-height: 28px;\n    color: var(--color-white);\n    padding: 14px 24px;\n    background: var(--color-main);\n    border-radius: 4px;\n    display: inline-block;\n    margin-top: 12px;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-detail__pay {\n        font-size: 16px;\n        line-height: 24px;\n        padding: 12px 20px;\n    }\n}\n\n.lk-detail__info {\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--color-blue-steel);\n}\n\n.lk-detail__cancel {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    display: flex;\n    align-items: center;\n    margin-top: 24px;\n    width: 154px;\n}\n\n.lk-detail__cancel svg {\n    margin-right: 8px;\n}\n\n.lk-detail__cancel svg path {\n    fill: var(--color-gray-window);\n}\n\n.lk-detail__list {\n    margin-top: 62px;\n}\n\n.lk-detail__list-title {\n    font-size: 24px;\n    line-height: 32px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 16px;\n}\n\n.lk-detail__list-return {\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    cursor: pointer;\n    margin: 20px 0;\n}\n\n.lk-detail__list-return svg {\n    margin-right: 8px;\n}\n\n.lk-detail__list-return svg path {\n    fill: var(--color-blackberry);\n}\n\n.lk-detail__item {\n    border-top: 1px solid var(--color-light-periwinkle-crayola);\n    padding-top: 16px;\n    margin-bottom: 16px;\n    display: flex;\n    align-items: flex-start;\n}\n\n.lk-detail__item-img {\n    display: block;\n    width: 120px;\n    height: 180px;\n    -o-object-fit: contain;\n    object-fit: contain;\n    margin-right: 16px;\n}\n\n@media screen and (max-width: 576px) {\n    .lk-detail__item-img {\n        width: 48px;\n        height: 73px;\n        margin-right: 12px;\n    }\n}\n\n.lk-detail__item-body {\n    width: 100%;\n}\n\n.lk-detail__item-title {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    margin-bottom: 4px;\n}\n\n.lk-detail__item-property {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n.lk-detail__item-right {\n    width: 75px;\n    text-align: right;\n    flex-shrink: 0;\n}\n\n.lk-detail__item-price {\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-granite);\n    margin-bottom: 4px;\n}\n\n.lk-detail__item-count {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n.lk-cashback__title {\n    font-size: 24px;\n    line-height: 32px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-cashback__title {\n        font-size: 20px;\n        line-height: 26px;\n    }\n}\n\n.lk-cashback__block {\n    margin-top: 24px;\n    margin-bottom: 32px;\n    background: var(--color-periwinkle-crayola);\n    border-radius: 4px;\n    padding: 16px 16px 16px 21px;\n    display: flex;\n    align-items: center;\n}\n\n.lk-cashback__block-icon {\n    flex-shrink: 0;\n    width: 30px;\n    height: 28px;\n    -o-object-fit: contain;\n    object-fit: contain;\n    display: block;\n    margin-right: 21px;\n}\n\n.lk-cashback__block-right {\n    width: 100%;\n}\n\n.lk-cashback__block-text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.lk-cashback__block-more {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blue-steel);\n    display: inline-block;\n}\n\n.lk-cashback__subtitle {\n    font-size: 16px;\n    line-height: 20px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 18px;\n}\n\n.lk-cashback .reviews-form__label {\n    width: 240px;\n    height: 40px;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-cashback .checkout-label {\n        display: block;\n    }\n}\n\n.lk-cashback__btn {\n    padding: 12px 20px;\n    font-size: 16px;\n    line-height: 24px;\n    border: none;\n}\n\n.lk-cashback__btn:focus {\n    outline: none;\n}\n\n.lk-cashback__top {\n    display: flex;\n    align-items: center;\n    margin-bottom: 46px;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__top {\n        flex-direction: column;\n        align-items: flex-start;\n        margin-bottom: 42px;\n    }\n}\n\n.lk-cashback__bonus {\n    padding: 16px 24px 16px 16px;\n    border-radius: 6px;\n    border: 1px solid var(--color-light-periwinkle-crayola);\n    margin-right: 32px;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__bonus {\n        margin-bottom: 24px;\n        margin-right: 0;\n        width: 100%;\n    }\n}\n\n.lk-cashback__bonus-count {\n    font-size: 48px;\n    line-height: 56px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n}\n\n.lk-cashback__bonus-text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.lk-cashback__bonus-more {\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--color-blue-steel);\n    display: inline-block;\n}\n\n.lk-cashback__bonus-empty {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__info {\n        width: 100%;\n    }\n}\n\n.lk-cashback__info-title {\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 4px;\n}\n\n.lk-cashback__info-text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    margin-bottom: 4px;\n}\n\n.lk-cashback__info-text:last-child {\n    margin-bottom: 0;\n}\n\n.lk-cashback__history {\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-granite);\n    margin-bottom: 16px;\n}\n\n.lk-cashback__head {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    margin-bottom: 16px;\n    display: flex;\n    align-items: center;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__head {\n        display: none;\n    }\n}\n\n.lk-cashback__head-name {\n    width: 45%;\n}\n\n.lk-cashback__head-date {\n    width: 30%;\n}\n\n.lk-cashback__head-operation {\n    width: 13%;\n}\n\n.lk-cashback__head-total {\n    width: 12%;\n}\n\n.lk-cashback__item {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    padding: 16px 0;\n    display: flex;\n    align-items: center;\n    border-top: 1px solid var(--color-light-periwinkle-crayola);\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__item {\n        flex-wrap: wrap;\n    }\n}\n\n.lk-cashback__item span {\n    display: none;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__item span {\n        display: inline-block;\n        color: var(--color-blackberry);\n    }\n}\n\n.lk-cashback__item:last-child {\n    margin-bottom: 32px;\n}\n\n.lk-cashback__item-name {\n    width: 45%;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__item-name {\n        width: 100%;\n    }\n}\n\n.lk-cashback__item-date {\n    width: 30%;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__item-date {\n        width: 100%;\n        font-size: 14px;\n        line-height: 18px;\n        color: var(--color-blackberry);\n    }\n}\n\n.lk-cashback__item-operation {\n    width: 13%;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__item-operation {\n        width: 50%;\n        margin-top: 8px;\n    }\n}\n\n.lk-cashback__item-plus {\n    color: var(--color-mint);\n}\n\n.lk-cashback__item-total {\n    width: 12%;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-cashback__item-total {\n        width: 50%;\n        text-align: right;\n        margin-top: 8px;\n    }\n}\n\n.lk-departure__title {\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 16px;\n}\n\n.lk-departure .reviews-form__label {\n    width: 240px;\n    height: 40px;\n}\n\n.lk-departure__btn {\n    font-size: 16px;\n    line-height: 24px;\n    padding: 12px 20px;\n    border: none;\n}\n\n.lk-departure__btn:focus {\n    outline: none;\n}\n\n.lk-departure__error {\n    margin-top: 32px;\n    max-width: 600px;\n    width: 100%;\n}\n\n.lk-departure__error-title {\n    font-size: 18px;\n    line-height: 24px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin-bottom: 8px;\n}\n\n.lk-departure__error-text {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n}\n\n.lk-departure__subtitle {\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-top: 32px;\n    margin-bottom: 16px;\n}\n\n.lk-departure__head {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    display: flex;\n    align-items: center;\n    padding-bottom: 16px;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-departure__head {\n        display: none;\n    }\n}\n\n.lk-departure__head-number {\n    width: 5%;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-departure__head-number {\n        width: 10%;\n    }\n}\n\n.lk-departure__head-date {\n    width: 30%;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-departure__head-date {\n        width: 20%;\n    }\n}\n\n.lk-departure__head-name {\n    width: 30%;\n}\n\n.lk-departure__head-address {\n    width: 30%;\n}\n\n.lk-departure__item {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-granite);\n    border-top: 1px solid var(--color-light-periwinkle-crayola);\n    padding: 16px 0;\n    display: flex;\n    align-items: center;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-departure__item {\n        align-items: flex-start;\n    }\n}\n\n.lk-departure__item span {\n    display: none;\n    font-size: 16px;\n    line-height: 22px;\n    color: var(--color-blackberry);\n    flex-shrink: 0;\n    margin-right: 12px;\n    width: 102px;\n    margin-bottom: 4px;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-departure__item span {\n        display: block;\n    }\n}\n\n.lk-departure__item-number {\n    width: 5%;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-departure__item-number {\n        width: 10%;\n    }\n}\n\n.lk-departure__item-wrap {\n    width: 90%;\n    display: flex;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-departure__item-wrap {\n        flex-wrap: wrap;\n    }\n}\n\n.lk-departure__item-date {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-departure__item-date {\n        align-items: flex-start;\n    }\n}\n\n.lk-departure__item-name {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-departure__item-name {\n        align-items: flex-start;\n    }\n}\n\n.lk-departure__item-address {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n@media screen and (max-width: 767px) {\n    .lk-departure__item-address {\n        align-items: flex-start;\n    }\n}\n\n.lk-profile__title {\n    font-size: 18px;\n    line-height: 24px;\n    color: var(--color-granite);\n    font-family: \"RalewaySemiBold\";\n    margin-bottom: 24px;\n}\n\n.lk-profile__personal {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    width: 400px;\n    margin: 0 auto;\n    max-width: 100%;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__personal {\n    }\n}\n\n.lk-profile__personal-remove {\n    display: none;\n    font-size: 14px;\n    line-height: 22px;\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-main);\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n    padding: 5px 12px;\n    margin: 8px 0 0 16px;\n}\n\n.lk-profile__personal-remove._active {\n    display: inline-block;\n}\n\n.lk-profile__personal-right {\n    padding-top: 30px;\n    display: flex;\n    align-items: center;\n    margin-left: 40px;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__personal-right {\n        padding-top: 0;\n        margin-bottom: 24px;\n        margin-left: 0;\n    }\n}\n\n\n.lk-profile__personal-label {\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--color-main);\n    font-family: \"RalewaySemiBold\";\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding: 5px 12px;\n    cursor: pointer;\n    border: 1px solid var(--color-pale-blue);\n    border-radius: 4px;\n    margin-left: 16px;\n    display: block;\n}\n\n.lk-profile__personal-input {\n    width: .1px;\n    height: .1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n}\n\n.lk-profile .checkout-label {\n    margin-bottom: 0;\n}\n\n.lk-profile .lk-filter {\n    width: 356px;\n    background: var(--color-light-periwinkle-crayola);\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile .lk-filter {\n        width: 100%;\n    }\n}\n\n.lk-profile__success {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-main);\n    font-family: \"RalewaySemiBold\";\n    padding: 8px 16px;\n    border-radius: 4px;\n    border: 1px solid var(--color-pale-blue);\n    margin-top: 12px;\n    background: transparent;\n}\n\n.lk-profile__wrap {\n    margin-top: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n}\n\n.lk-profile__block {\n    text-align: center;\n    padding: 15px;\n}\n\n.lk-profile__save {\n    font-size: 16px;\n    line-height: 24px;\n    margin-right: 20px;\n    padding: 12px 20px;\n    border: none;\n}\n\n.lk-profile__save-info {\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    line-height: 22px;\n    color: var(--color-blue-steel);\n}\n\n.lk-profile__save-info svg {\n    margin-right: 8px;\n}\n\n.lk-profile__notice {\n    margin-top: 64px;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__notice .lk-profile__title {\n        margin-bottom: 12px;\n    }\n}\n\n.lk-profile__head {\n    display: flex;\n    align-items: center;\n    padding-bottom: 18px;\n    text-align: center;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__head {\n        display: none;\n    }\n}\n\n.lk-profile__head-notification {\n    width: 32%;\n    text-align: left;\n}\n\n.lk-profile__head-email {\n    width: 17%;\n}\n\n.lk-profile__head-push {\n    width: 17%;\n}\n\n.lk-profile__head-sms {\n    width: 17%;\n}\n\n.lk-profile__head-viber {\n    width: 17%;\n}\n\n.lk-profile__item {\n    display: flex;\n    align-items: center;\n    border-top: 1px solid var(--color-light-periwinkle-crayola);\n    padding: 18px 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item {\n        border-top: none;\n        flex-wrap: wrap;\n        padding: 12px 0;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item .checkout-label {\n        display: block;\n        margin-bottom: 12px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item .checkout-label__text {\n        padding-left: 0;\n    }\n}\n\n.lk-profile__item .checkout-label__text span {\n    display: none;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item .checkout-label__text span {\n        display: inline-block;\n    }\n}\n\n.lk-profile__item .checkout-label__text:before {\n    position: absolute;\n    content: '';\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item .checkout-label__text:before {\n        right: 0;\n        left: initial;\n        -webkit-transform: translate(0, -50%);\n        transform: translate(0, -50%);\n        width: 34px;\n        height: 14px;\n        background: var(--color-light-periwinkle-crayola);\n        border-radius: 500px;\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item .checkout-label__text:after {\n        position: absolute;\n        content: '';\n        width: 20px;\n        height: 20px;\n        right: 0;\n        top: 50%;\n        -webkit-transform: translateY(-50%);\n        transform: translateY(-50%);\n        background: var(--color-main);\n        border-radius: 50%;\n        transition: right .3s linear;\n    }\n}\n\n.lk-profile__item .checkout-label__input:checked + .checkout-label__text:after {\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item .checkout-label__input:checked + .checkout-label__text:after {\n        position: absolute;\n        content: '';\n        width: 20px;\n        height: 20px;\n        top: 50%;\n        -webkit-transform: translateY(-50%);\n        transform: translateY(-50%);\n        background: var(--color-main);\n        border-radius: 50%;\n        right: 20px;\n        left: initial;\n    }\n}\n\n.lk-profile__item-notification {\n    width: 32%;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item-notification {\n        width: 100%;\n        font-size: 16px;\n        line-height: 24px;\n        color: var(--color-granite);\n        font-family: \"RalewaySemiBold\";\n        margin-bottom: 12px;\n    }\n}\n\n.lk-profile__item-email {\n    width: 17%;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item-email {\n        width: 100%;\n    }\n}\n\n.lk-profile__item-push {\n    width: 17%;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item-push {\n        width: 100%;\n    }\n}\n\n.lk-profile__item-sms {\n    width: 17%;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item-sms {\n        width: 100%;\n    }\n}\n\n.lk-profile__item-viber {\n    width: 17%;\n}\n\n@media screen and (max-width: 1024px) {\n    .lk-profile__item-viber {\n        width: 100%;\n    }\n}\n\n.lk-profile .reviews-form__input::-webkit-datetime-edit {\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--color-blackberry);\n    font-family: \"RalewayRegular\";\n}\n\n.lk-profile .reviews-form__input::-webkit-calendar-picker-indicator {\n    background: url(\"../../../assets/site/img/calendar.svg\") no-repeat;\n    background-size: contain;\n}\n\n.lk-profile__radio {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    gap: 30px;\n}\n\n.lk-profile__radio > label {\n\n}\n\n.lk-profile__radio > label > input {\n}\n\n.lk-profile__radio > label > span {\n    display: inline-block;\n    padding-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
